<template>
  <v-text-field
    ref="field"
    v-model="model"
    :prefix="prefix"
    :error-messages="errorMessages"
    v-bind="$attrs"
    @focus="onFocus"
    @input="onKeyUp"
    @change="onChange"
    @blur="onBlur"
  />
</template>

<script>
function tryParseFloat(str, defaultValue) {
  var retValue = defaultValue
  if (str !== null) {
    if (str.length > 0) {
      if (!isNaN(str)) {
        retValue = parseFloat(str)
      }
    }
  }
  return retValue
}
export default {
  props: {
    value: null,
    'error-messages': null,
    allowNegative: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    thousandsSeparator: {
      type: String,
      default: ',',
    },
    decimalSeparator: {
      type: String,
      default: '.',
    },
    decimalDigits: {
      type: Number,
      default: 2,
    },
    languageCode: {
      type: String,
      default: 'en-US',
    },
  },
  data() {
    return {
      numberValue: this.value,
      model: this.value,
      isMasked: true,
      thousandsSeparatorRegex: new RegExp(`\\${this.thousandsSeparator}`, 'g'),
      decimalSeparatorRegex: new RegExp(`\\${this.decimalSeparator}`, 'g'),
    }
  },
  computed: {
    decimalOrder() {
      return Math.pow(10, Number(this.decimalDigits) || 2)
    },
  },
  watch: {
    numberValue(v) {
      this.$emit('input', v)
    },
    value(v) {
      this.numberValue = v || ''
      if (!this.$refs.field.isFocused) {
        this.format()
      }
    },
  },
  created() {
    this.format()
  },
  methods: {
    onFocus() {
      this.isMasked = false
      this.updateModel()
    },
    onBlur() {
      if (this.$listeners.blur) this.$listeners.blur()
      this.isMasked = true
      this.format()
    },
    onKeyUp() {
      this.updateNumberValue()
    },
    onChange() {
      if (this.$listeners.change) this.$listeners.change()
    },
    updateNumberValue() {
      let v = this.model || ''
      let parsed
      v = v.replace(this.thousandsSeparatorRegex, '')
      if (this.decimalSeparator !== '.') {
        v = v.replace(this.decimalSeparatorRegex, this.thousandsSeparator)
      }
      const result = tryParseFloat(v)
      if (!result) parsed = 0
      else parsed = result
      if (!this.allowNegative && result < 0) parsed = 0
      this.numberValue =
        Math.round(parsed * this.decimalOrder) / this.decimalOrder || ''
    },

    updateModel() {
      let v = (this.numberValue || 0).toString()
      v = v.replace(this.thousandsSeparatorRegex, this.decimalSeparator)
      this.model = v
    },
    format() {
      let v = this.numberValue || 0
      v = v.toLocaleString(this.languageCode)
      if (
        v.length !== 1 &&
        v.slice(v.indexOf(this.decimalSeparator) + 1).length === 1
      ) {
        v += '0'
      }
      if (v !== '' && v.indexOf(this.decimalSeparator) === -1) {
        v += this.decimalSeparator
        for (let i = 0; i < this.decimalDigits; i++) {
          v += '0'
        }
      }

      this.model = v ? this.prefix + v + this.suffix : v
    },
  },
}
</script>

<style lang="scss" scoped></style>
